import { setAttr } from '/lib/redom.es.js';

function getLeftPosition(elementRect, anchorRect, placeOnCenter) {

  if (placeOnCenter === false) {
    return anchorRect.left;
  }

  if (placeOnCenter === 'right') {
    return (anchorRect.left + anchorRect.width) - elementRect.width;
  }

  return (anchorRect.left + (anchorRect.width / 2)) - (elementRect.width / 2);

}

function getTopPosition(elementRect, anchorRect, placeOnCenter) {

  if (placeOnCenter === false) {
    return anchorRect.top;
  }

  return (anchorRect.top + (anchorRect.height / 2)) - (elementRect.height / 2);

}

function getTopPositionCoordinates(elementRect, anchorRect, viewportRect, verticalOffset, horizontalOffset, placeOnCenter) {

  const availableVerticalSpace = anchorRect.top - viewportRect.top;
  const neededVerticalSpace = elementRect.height + verticalOffset;

  if (availableVerticalSpace < neededVerticalSpace) {
    return null;
  }

  const availableHorizontalSpace = viewportRect.width;
  const neededHorizontalSpace = elementRect.width + horizontalOffset;

  if (availableHorizontalSpace < neededHorizontalSpace) {
    return null;
  }

  const top = anchorRect.top - (neededVerticalSpace);
  let left = getLeftPosition(elementRect, anchorRect, placeOnCenter);

  const availableHorizontalSpaceFromAnchor = (viewportRect.left + viewportRect.width) - left;

  // if the element will go beyond right of the viewport, display it till the viewport
  if (neededHorizontalSpace > availableHorizontalSpaceFromAnchor) {
    left -= (neededHorizontalSpace - availableHorizontalSpaceFromAnchor);
  }

  // if the element will start before the viewport, display it from the viewport
  if (viewportRect.left > left) {
    left = viewportRect.left + horizontalOffset;
  }

  // if the element will go beyond the right of the viewport again, say, there is no space
  if ((left + elementRect.width) > (viewportRect.left + viewportRect.width)) {
    return null;
  }

  return { top, left, height: elementRect.height };

}

function getRightPositionCoordinates(elementRect, anchorRect, viewportRect, verticalOffset, horizontalOffset, placeOnCenter) {

  const availableVerticalSpace = viewportRect.height;
  const neededVerticalSpace = elementRect.height + verticalOffset;

  if (availableVerticalSpace < neededVerticalSpace) {
    return null;
  }

  const availableHorizontalSpace = (viewportRect.left + viewportRect.width) - (anchorRect.left + anchorRect.width);
  const neededHorizontalSpace = elementRect.width + horizontalOffset;

  if (availableHorizontalSpace < neededHorizontalSpace) {
    return null;
  }

  let top = getTopPosition(elementRect, anchorRect, placeOnCenter);
  let left = anchorRect.left + anchorRect.width + horizontalOffset;

  const availableVerticalSpaceFromAnchor = (viewportRect.top + viewportRect.height) - top;

  // if the element will go below the bottom, display it till the bottom
  if (neededVerticalSpace > availableVerticalSpaceFromAnchor) {
    top -= (neededVerticalSpace - availableVerticalSpaceFromAnchor);
  }

  // if the element will go above the top, display it from the top
  if (viewportRect.top > top) {
    top = viewportRect.top + verticalOffset;
  }

  // if the element will go below the bottom again, say, there is no space.
  if ((top + elementRect.height) > (viewportRect.top + viewportRect.height)) {
    return null;
  }

  return { top, left, height: elementRect.height };

}

function getBottomPositionCoordinates(elementRect, anchorRect, viewportRect, verticalOffset, horizontalOffset, placeOnCenter) {

  const availableVerticalSpace = (viewportRect.top + viewportRect.height) - (anchorRect.top + anchorRect.height);
  const neededVerticalSpace = elementRect.height + verticalOffset;

  if (availableVerticalSpace < neededVerticalSpace) {
    return null;
  }

  const availableHorizontalSpace = viewportRect.width;
  const neededHorizontalSpace = elementRect.width + horizontalOffset;

  if (availableHorizontalSpace < neededHorizontalSpace) {
    return null;
  }

  const top = anchorRect.top + anchorRect.height + verticalOffset;
  let left = getLeftPosition(elementRect, anchorRect, placeOnCenter);

  const availableHorizontalSpaceFromAnchor = (viewportRect.left + viewportRect.width) - left;

  // if the element will go beyond right of the viewport, display it till the viewport
  if (neededHorizontalSpace > availableHorizontalSpaceFromAnchor) {
    left -= (neededHorizontalSpace - availableHorizontalSpaceFromAnchor);
  }

  // if the element will start before the viewport, display it from the viewport
  if (viewportRect.left > left) {
    left = viewportRect.left + horizontalOffset;
  }

  // if the element will go beyond the right of the viewport again, say, there is no space
  if ((left + elementRect.width) > (viewportRect.left + viewportRect.width)) {
    return null;
  }

  return { top, left, height: elementRect.height };

}

function getLeftPositionCoordinates(elementRect, anchorRect, viewportRect, verticalOffset, horizontalOffset, placeOnCenter) {

  const availableVerticalSpace = viewportRect.height;
  const neededVerticalSpace = elementRect.height + verticalOffset;

  if (availableVerticalSpace < neededVerticalSpace) {
    return null;
  }

  const availableHorizontalSpace = (anchorRect.left - viewportRect.left);
  const neededHorizontalSpace = elementRect.width + horizontalOffset;

  if (availableHorizontalSpace < neededHorizontalSpace) {
    return null;
  }

  let top = getTopPosition(elementRect, anchorRect, placeOnCenter);
  let left = anchorRect.left - neededHorizontalSpace;

  const availableVerticalSpaceFromAnchor = (viewportRect.top + viewportRect.height) - top;

  // if the element will go below the bottom, display it till the bottom
  if (neededVerticalSpace > availableVerticalSpaceFromAnchor) {
    top -= (neededVerticalSpace - availableVerticalSpaceFromAnchor);
  }

  // if the element will go above the top, display it from the top
  if (viewportRect.top > top) {
    top = viewportRect.top + verticalOffset;
  }

  // if the element will go below the bottom again, say, there is no space.
  if ((top + elementRect.height) > (viewportRect.top + viewportRect.height)) {
    return null;
  }

  return { top, left, height: elementRect.height };

}

function positionElement(element, position) {

  setAttr(element, {
    style: {
      position: 'fixed',
      top: position.top + 'px',
      left: position.left + 'px',
      height: position.height + 'px'
    }
  });

}

function getOrderOfPositionChecks(startSide = 'top') {

  if (startSide === 'top') {
    return ['top', 'right', 'bottom', 'left'];
  }

  if (startSide === 'right') {
    return ['right', 'bottom', 'left', 'top'];
  }

  if (startSide === 'bottom') {
    return ['bottom', 'left', 'top', 'right'];
  }

  if (startSide === 'left') {
    return ['left', 'top', 'right', 'bottom'];
  }

  return ['top', 'right', 'bottom', 'left'];

}

const positioners = {
  top: topPositioner,
  right: rightPositioner,
  bottom: bottomPositioner,
  left: leftPositioner
};

function topPositioner(element, elementRect, anchorRect, viewportRect, verticalOffset, horizontalOffset, placeOnCenter) {

  const topPositionCoordinates = getTopPositionCoordinates(elementRect, anchorRect, viewportRect, verticalOffset, horizontalOffset, placeOnCenter);

  if (topPositionCoordinates !== null) {
    positionElement(element, topPositionCoordinates);
    return true;
  }

  return false;

}

function rightPositioner(element, elementRect, anchorRect, viewportRect, verticalOffset, horizontalOffset, placeOnCenter) {

  const rightPositionCoordinates = getRightPositionCoordinates(elementRect, anchorRect, viewportRect, verticalOffset, horizontalOffset, placeOnCenter);

  if (rightPositionCoordinates !== null) {
    positionElement(element, rightPositionCoordinates);
    return true;
  }

  return false;

}

function bottomPositioner(element, elementRect, anchorRect, viewportRect, verticalOffset, horizontalOffset, placeOnCenter) {

  const bottomPositionCoordinates = getBottomPositionCoordinates(elementRect, anchorRect, viewportRect, verticalOffset, horizontalOffset, placeOnCenter);

  if (bottomPositionCoordinates !== null) {
    positionElement(element, bottomPositionCoordinates);
    return true;
  }

  return false;

}

function leftPositioner(element, elementRect, anchorRect, viewportRect, verticalOffset, horizontalOffset, placeOnCenter) {

  const leftPositionCoordinates = getLeftPositionCoordinates(elementRect, anchorRect, viewportRect, verticalOffset, horizontalOffset, placeOnCenter);

  if (leftPositionCoordinates !== null) {
    positionElement(element, leftPositionCoordinates);
    return true;
  }

  return false;

}

export function displayElementAroundAnchor(element, anchorElement, viewportElement = document.body, verticalOffset = 0, horizontalOffset = 0, startSide, placeOnCenter = false, positionableSides) {

  const elementRect = element.getBoundingClientRect();
  const anchorRect = anchorElement.getBoundingClientRect();
  const viewportRect = viewportElement.getBoundingClientRect();

  const positionChecksOrder = positionableSides || getOrderOfPositionChecks(startSide);

  for (let side of positionChecksOrder) {

    const positioned = positioners[side](element, elementRect, anchorRect, viewportRect, verticalOffset, horizontalOffset, placeOnCenter);

    if (positioned === false) {
      // eslint-disable-next-line no-console
      // console.log(`"${side}" position is not possible. Trying next one!`);
    } else {
      return side;
    }

  }

  // eslint-disable-next-line no-console
  // console.log('Element does not fit in any side! So, not displayed!');

  return false;

}

export function getOppositeSide(side) {

  if (side === 'top') {
    return 'bottom';
  }

  if (side === 'right') {
    return 'left';
  }

  if (side === 'bottom') {
    return 'top';
  }

  if (side === 'left') {
    return 'right';
  }

  return null;

}

export function leftDistance(elementOne, elementTwo) {

  const elementOneRectangle = elementOne.getBoundingClientRect();
  const elementTwoRectangle = elementTwo.getBoundingClientRect();

  return elementTwoRectangle.x - elementOneRectangle.x;

}